import type { KeyRotation } from "legacy/api/SigningKeyRotationApi";
import { Slice } from "store/utils/slice";
import type { EntitiesStateWithMeta } from "store/utils/types";

import type { AgentWithHealth } from "./client";

export type AgentMeta = {
  organizationId?: string;
  keyRotations?: KeyRotation[];
};

type AgentState = EntitiesStateWithMeta<AgentWithHealth, AgentMeta>;

export default new Slice<AgentState>("agents", {
  entities: {},
  loading: {},
  errors: {},
  meta: {},
});
